import { API_PATHS } from '@/api';
import { getData } from '@/api/crudHandlers';
import {
  TAxiosResponseSuccess,
  TFiltersRequestParams,
  IFiltersResponseParams,
  EmployeesStatusEnum,
  ICompaniesFilterResponseParams,
  IGetCompaniesRequest,
  IGetCohortsRequest,
  ICohortsFilterResponseParams,
} from '@/types';

export const filtersHandlers = {
  GET_FILTERS(
    type: TFiltersRequestParams,
  ): TAxiosResponseSuccess<IFiltersResponseParams<EmployeesStatusEnum>> {
    return getData<IFiltersResponseParams<EmployeesStatusEnum>>(
      API_PATHS.FILTERS.GET_FILTERS.BY_ID(type),
    );
  },
  GET_COMPANY(
    params?: IGetCompaniesRequest,
  ): TAxiosResponseSuccess<ICompaniesFilterResponseParams> {
    return getData<ICompaniesFilterResponseParams>(API_PATHS.FILTERS.GET_COMPANIES._, { params });
  },
  GET_COHORTS(params?: IGetCohortsRequest): TAxiosResponseSuccess<ICohortsFilterResponseParams[]> {
    return getData<ICohortsFilterResponseParams[]>(API_PATHS.FILTERS.GET_COHORTS._, { params });
  },
};
